import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLayout from "../../components/templetes/popupLayout";
import { StyledButton } from "../../components/atoms/button";
import { ValidationInput } from "../../components/atoms/validation/ValidationInput";
import { TWO_FACTOR_AUTH_KEY } from "../TwoFactorAuthKey";
const TwoFactorAuthPopup = ({ title, target,
    authMethod = "MAIL",
    requestOtp = () => { },
    closePopup = () => { },
    onSubmit = () => { },
    checkExpiration = () => { },
    maxWidth = "100%"
}) => {
    const { t } = useTranslation();
    const isTotp = authMethod === "TOTP";
    const [code, setCode] = useState("")
    const [timeout, setTimeoutJob] = useState(null)
    const [expiration, setExpiration] = useState(null)
    const [error, setError] = useState(null)
    const [isSendingOtp, setSendingOTP] = useState(false)
    const checkTwoFactorAuthCodeExpiration = () => {
        setTimeoutJob(setTimeout(() => {
            checkExpiration((result) => {
                setExpiration(result.view)
                if (result.expiration > 0)
                    checkTwoFactorAuthCodeExpiration()
                else{
                    setError(t("mfa.codeExpired"))
                    setExpiration(null)
                    sessionStorage.removeItem(TWO_FACTOR_AUTH_KEY)
                }
            })
        }, 1000));
    }
    useEffect(() => {
        return () => {
            clearTimeout(timeout)
        }
    }, [timeout])
    const submitTwoFactorAuthCode = () => {
        onSubmit({
            code: code
        }, (result) => {
            setError(result.message)
        })
    }
    return (
        <PopupLayout
            theme="primary"
            data-size="lg"
            style={{ maxWidth: maxWidth }}
            title={title}
            closePopup={closePopup}
            button={
                <StyledButton
                    type="text"
                    data-bg="primary"
                    size="md"
                    onClick={submitTwoFactorAuthCode}
                >
                    {t("common.confirm")}
                </StyledButton>
            }>
            <ValidationInput
                label={t("mfa.method")}
                style={{ cursor: 'default' }}
                disabled value={target} onChange={() => { }}>

            </ValidationInput>
            {isTotp && (
                <p style={{ marginBottom: 12, color: "#666", fontSize: 13 }}>
                    {t("mfa.totp.hint")}
                </p>
            )}
            <div style={{ display: 'flex', width: "calc(100%)" }} >
                <div style={{ flexGrow: 1 }}>
                    <ValidationInput
                        style={{ minWidth: "30%" }}
                        label={t("mfa.code")}
                        value={code}
                        onKeyDown={e => {
                            if (e.code == "Enter" || e.code == "NumpadEnter")
                                submitTwoFactorAuthCode()
                        }}
                        onChange={e => {
                            setCode(e.target.value)
                        }} />
                    {
                        !isTotp && expiration != null &&
                        <p style={{ height: 30, textAlign: 'right', marginRight: 15 }}>{t("mfa.expiration", { sec: expiration })}</p>
                    }
                    {
                        error != null &&
                        <p style={{ height: 30, textAlign: 'right', marginRight: 15, color: 'hsla(0, 79%, 63%, 1)' }}>{t("mfa.message", { message: error })}</p>
                    }
                </div>
                {!isTotp && (
                    <StyledButton
                        style={{ marginTop: 29, cursor: !isSendingOtp ? 'pointer' : 'progress' }}
                        type="text"
                        data-bg={isSendingOtp ? "lightgray" : "primary"}
                        size="md"
                        onClick={() => {
                            if (isSendingOtp)
                                return;
                            setSendingOTP(true)
                            requestOtp(() => {
                                setSendingOTP(false)
                                setError(null)
                                checkTwoFactorAuthCodeExpiration()
                            })
                        }}
                    > {t("mfa.send")}
                    </StyledButton>
                )}
            </div>

        </PopupLayout>
    )
}
export default TwoFactorAuthPopup
